const weightTitle = { default: "600", small: "400" };
const detailVariant = { default: "large", small: "small" };

export const fallbackValues = {
  weightTitle,
  detailVariant
};
